import React, { useMemo } from "react";
interface LocationProps {
  lat: number;
  long: number;
}
export const Location = (props: LocationProps) => {
  const [selectedUnits, setSelectedUnits] = React.useState("degrees");
  function ConvertDDToDMS(dd) {
    var deg = dd | 0;
    var frac = Math.abs(dd - deg);
    var min = (frac * 60) | 0;
    var sec = frac * 3600 - min * 60;
    return deg + "° " + min + "' " + Math.round(sec) + '"';
  }
  const dmsLat = useMemo(() => {
    return ConvertDDToDMS(props.lat);
  }, [props.lat]);

  const dmsLng = useMemo(() => {
    return ConvertDDToDMS(props.long);
  }, [props.long]);

  return (
    <div className="flex items-center justify-around w-full">
      <div className="text-md flex-1">
        <p>
          Longitude:{" "}
          {selectedUnits === "degrees" ? props.long.toFixed(6) : dmsLng}
        </p>
        <p>
          Latitude:{" "}
          {selectedUnits === "degrees" ? props.lat.toFixed(6) : dmsLat}
        </p>
      </div>
      <select
        className="border border-gray-300 rounded-md p-1 ml-2"
        value={selectedUnits}
        onChange={(e) => setSelectedUnits(e.target.value)}
      >
        <option value="degrees">Degrees</option>
        <option value="dms">DMS</option>
      </select>
    </div>
  );
};
